import { RootState } from "../store";

export const selectCommonLoading = (state: RootState) => state.common.loading;